import { createAsyncThunk } from '@reduxjs/toolkit';
import { cache, cacheKey } from '@fogia/core-server/util/ssrCache';
import ResolveApp from '@fogia/core-web/libs/GrebbCommerceAPI/Content/ResolveApp';
import { getState } from '@fogia/core-web/state';

export default createAsyncThunk('application/resolve', async (data: any) => {
    const { url = '', parameters = {}, origin } = data;
    const { currentHref } = getState().application;

    let resolvedUrl = url;

    if (url === '') {
        resolvedUrl = currentHref;
    }

    return cache(() => ResolveApp(resolvedUrl, parameters, origin), cacheKey(resolvedUrl, parameters, origin));
});
